import React from "react";
import "./Summary.css";

export const Summary = () => {
  return (
    <div className="summary-container">
      <h3>ABOUT</h3>
      <p>
        Being an avid video gamer, I was always fascinated with how digital
        applications worked underneath the hood. At this point in my young
        career, I've had the honor of working for{" "}
        <a href="https://www.mlb.com">America's pastime</a> and a{" "}
        <a href="https://www.target.com">Fortune 50 retailer.</a>
        <br />
        <br />
        Outside of work hours, I mentor current undergraduate Computer Science
        students at the University of Minnesota - Twin Cities to simulate
        real-world experiences while creating projects in the esports space.
        <br />
        <br />
        When I'm away-from-keyboard, I'm watching Minnesota sports teams (Twins,
        Wild, Vikings, and Loons) and the top soccer teams, exercising, and
        watching the latest Star Wars or Marvel releases.
      </p>
    </div>
  );
};
